var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js??ref--18-2!../../../../node_modules/sass-loader/dist/cjs.js??ref--18-3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BraintreeHostedFieldsForm.vue?vue&type=style&index=0&id=4f8c20d1&prod&lang=scss&scoped=true");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};